import { getAddressList, addAddress, removeAddress, updateAddress }  from 'Api/userApi'
import { formatUpdateAddress, formatAddAddress } from 'Formatters/addressFormatter'
import { parseAddressList }  from 'Parsers/addressParser'

const state = {
  requesting: {
    addressList: false,
    addAddress: false,
    editAddress: false,
    deleteAddres: false,
  },

  pagination: {
    current: 1,
    limit: 1,
  },

  searchSort: false,
  searchTerm: '',

  sortList: [
    { id: 0, name: 'Mais recentes', value: false },
    { id: 1, name: 'Ordem alfabética',  value: true },
  ],

  addressList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },
  set_address_list(state, addressList) {
    state.addressList = addressList
  },
  set_pagination(state, pagination) {
    state.pagination = pagination
  },
  set_search_term(state, searchTerm) {
    state.searchTerm = searchTerm
  },
  set_search_sort(state, searchSort) {
    state.searchSort = searchSort
  },
}

const actions = {
  async getAddressList({ commit }) {
    const { searchTerm, searchSort, pagination } = state
    commit('request_start', 'addressList')

    try {
      let options = {
        pageSize: 9
      }

      if (searchTerm !== '') {
        options.filter = searchTerm
      }

      if (searchSort !== '') {
        options.alphabeticalOrder = searchSort
      }

      const { data } = await getAddressList(pagination.current, options)

      const addressList = parseAddressList(data)
      commit('set_address_list', addressList)
      commit('set_pagination', { current: data.page, limit: data.pageCount })

      commit('request_success', 'addressList')

      return addressList
    } catch (err) {
      commit('request_failure', 'addressList')

      throw err
    }
  },

  async searchAddress({ commit, dispatch }, query) {
    commit('set_search_term', query)

    try {
      const result = await dispatch('getAddressList')

      return result
    } catch (err) {
      throw err
    }
  },

  async paginate({ state, commit, dispatch }, page) {
    const { pagination } = state
    commit('set_pagination', Object.assign({}, pagination, { current: page }))

    try {
      const result = await dispatch('getAddressList')

      return result
    } catch (err) {
      throw err
    }
  },

  async addAddress({ commit }, address) {
    commit('request_start', 'addAddress')

    try {
      const data = formatAddAddress(address)
      const result = await addAddress(data)

      commit('request_success', 'addAddress')

      return result
    } catch (err) {
      commit('request_failure', 'addAddress')

      throw err
    }
  },

  async editAddress({ commit }, address) {
    commit('request_start', 'editAddress')

    try {
      const data = formatUpdateAddress(address)
      const result = await updateAddress(data)

      commit('request_success', 'editAddress')

      return result
    } catch (err) {
      commit('request_failure', 'editAddress')
      throw err
    }
  },

  async removeAddress({ commit }, id) {
    commit('request_start', 'deleteAddres')

    try {
      const result = await removeAddress(id)

      commit('request_success', 'deleteAddres')

      return result
    } catch (err) {
      commit('request_failure', 'deleteAddres')

      throw err
    }
  },

  updateSort({ commit }, value) {
    commit('set_search_sort', value)
  },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}